import TextField from '@mui/material/TextField'
import styled, { css } from 'styled-components'

export const Input = styled(TextField)`
  && {
  }
`

// Modern Input styled components with focus states
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #404040;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  color: #171717;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  outline: none;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  
  &::placeholder {
    color: #A3A3A3;
  }
  
  &:hover:not(:disabled):not(:focus) {
    border-color: #D4D4D4;
    background: #F5F5F5;
  }
  
  &:focus {
    background: white;
    border-color: #FF9F1C;
    box-shadow: 0 0 0 3px rgba(255, 159, 28, 0.1);
  }
  
  &:disabled {
    background: #F5F5F5;
    color: #A3A3A3;
    cursor: not-allowed;
  }
  
  ${props => props.hasError && css`
    border-color: #EF4444 !important;
    
    &:focus {
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
    }
  `}
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  color: #171717;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  outline: none;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 100px;
  resize: vertical;
  font-family: inherit;
  
  &::placeholder {
    color: #A3A3A3;
  }
  
  &:hover:not(:disabled):not(:focus) {
    border-color: #D4D4D4;
    background: #F5F5F5;
  }
  
  &:focus {
    background: white;
    border-color: #FF9F1C;
    box-shadow: 0 0 0 3px rgba(255, 159, 28, 0.1);
  }
  
  &:disabled {
    background: #F5F5F5;
    color: #A3A3A3;
    cursor: not-allowed;
  }
  
  ${props => props.hasError && css`
    border-color: #EF4444 !important;
    
    &:focus {
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
    }
  `}
`;

export const ErrorMessage = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #EF4444;
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const HelperText = styled.span`
  font-size: 13px;
  color: #737373;
`;

// Select styled component
export const StyledSelect = styled.select`
  width: 100%;
  padding: 12px 14px;
  padding-right: 40px;
  font-size: 15px;
  color: #171717;
  background: #FAFAFA;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  outline: none;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23737373' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  
  &:hover:not(:disabled):not(:focus) {
    border-color: #D4D4D4;
    background-color: #F5F5F5;
  }
  
  &:focus {
    background-color: white;
    border-color: #FF9F1C;
    box-shadow: 0 0 0 3px rgba(255, 159, 28, 0.1);
  }
  
  &:disabled {
    background-color: #F5F5F5;
    color: #A3A3A3;
    cursor: not-allowed;
  }
  
  ${props => props.hasError && css`
    border-color: #EF4444 !important;
    
    &:focus {
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
    }
  `}
`;
